var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iv-breadcrumb',_vm._l((_vm.list),function(item,index){return _c('iv-breadcrumb-item',{key:index,attrs:{"to":item.to}},[_vm._v(_vm._s(item.title))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }